import React from 'react';
import PropTypes from 'prop-types';
import CwImage from '../cwimage/CwImage';
import css from './CwPill.scss';
import IconPath from 'src/utils/IconPath';

/** @type {React.StatelessComponent} */
const CwPill = ({ id, value, deletePillIcon = null, onDeletePill = null }) => {
  return (
    <span
      className={css.pill}
      key={id}
    >
      {value}
      {onDeletePill ?
        <CwImage
          onClick={() => { onDeletePill({ id, value }); }}
          className={css.closeIcon}
          isInlineSVG={false}
          src={deletePillIcon} />
        : null}
    </span>);
};

CwPill.propTypes = {
  /**
   * The key to be used for this pill
   */
  id: PropTypes.any.isRequired,
  /**
   * The value to display on the pill
   */
  value: PropTypes.string.isRequired,
  /**
  * The icon to display on the pill
  */
  deletePillIcon: PropTypes.string,
  /**
  * The function to be called when the pill is closed
  */
  onDeletePill: PropTypes.func
};

CwPill.defaultProps = {
  deletePillIcon: IconPath.get('Action_Close')
};

export default CwPill;


// WEBPACK FOOTER //
// ./src/components/cwpill/CwPill.jsx